import { render, staticRenderFns } from "./ScimDiffDialog.vue?vue&type=template&id=4d94feeb&scoped=true"
import script from "./ScimDiffDialog.vue?vue&type=script&lang=ts"
export * from "./ScimDiffDialog.vue?vue&type=script&lang=ts"
import style0 from "./ScimDiffDialog.vue?vue&type=style&index=0&id=4d94feeb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94feeb",
  null
  
)

export default component.exports